/**
 * Wrapper around fetch that includes credentials for CORS requests
 * @param input - URL or Request object
 * @param init - RequestInit options
 * @returns Promise<Response>
 */
export function fetchWithCredentials(
  input: string | Request,
  init?: RequestInit
): Promise<Response> {
  return fetch(input, {
    ...init,
    credentials: 'include',
    headers: {
      ...init?.headers,
    },
  });
}
